module.exports = __webpack_public_path__ + "static/media/400337_02.489e2e1e.png";